import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ORGANIZATIONS_PATH } from './../../../utilities/devex_paths';

const Result = ({ org, displayNewLogo }) => {
  const {
    is_devex_member,
    logo_url,
    name,
    slug_and_id,
    countries_with_offices,
    organization_types,
    organization_size,
    active_jobs_count,
    description,
  } = org;

  const cloudinaryBaseUrl = 'https://res.cloudinary.com/devex/image/fetch/c_fit,f_auto,q_auto,h_70,w_140/';

  return (
    <li className='result-summary-box mb-48' aria-label='organization result'>
      <div className={
        classNames(
          'search-result',
          { featured: is_devex_member && !displayNewLogo },
          {'is-devex-member': is_devex_member && displayNewLogo },
        )
      }>
        <ul className='top-border-list'>
          <li className='top p-35' aria-label='organization details'>
            <div className='logo-container mb-xs-3'>
              {logo_url && (
                <img
                  data-testid='organizationLogo'
                  alt='Organization logo'
                  src={cloudinaryBaseUrl + logo_url}
                  className='me-35'
                />
              )}
            </div>
            <div className='info-container'>
              <a className='link-blue-orange' href={`${ORGANIZATIONS_PATH}/${slug_and_id}`}>
                <h2 className='fs-4 mb-0'>{name}</h2>
              </a>
              {Boolean(countries_with_offices?.length) && (
                <small className='text-gray-li' data-testid='offices'>
                  Offices in{' '}
                  {countries_with_offices
                    .slice(0, 4)
                    .map((office) => office.name)
                    .join(', ')}
                  {countries_with_offices.length > 4 ? ' and more' : ''}
                </small>
              )}
              <div className='mt-35'>
                {organization_types.join(', ')}
                {organization_size !== 'Unknown' &&
                  Boolean(organization_types.length) &&
                  `, Staff ${organization_size}`}
              </div>
            </div>
          </li>
          {Boolean(active_jobs_count) && (
            <li className='links px-35 py-25' aria-label='hiring now'>
              <a
                className='devex-primary-badge me-25 py-1 px-3'
                href={`${ORGANIZATIONS_PATH}/${slug_and_id}#careers`}
              >
                Hiring now
              </a>
            </li>
          )}
          {Boolean(description?.length) && (
            <li className='description p-35 text-gray' aria-label='description'>
              <span
                dangerouslySetInnerHTML={{
                  __html: `${description.slice(0, 360)} ${
                    description.length > 360 ? '&hellip;' : ''
                  }`,
                }}
              />
              {description.length > 360 && (
                <a
                  className='small strong ms-15 link-blue-orange'
                  href={`${ORGANIZATIONS_PATH}/${slug_and_id}`}
                >
                  Read more
                </a>
              )}
            </li>
          )}
        </ul>
      </div>
    </li>
  );
};

Result.propTypes = {
  displayNewLogo: PropTypes.bool.isRequired,
  org: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug_and_id: PropTypes.string.isRequired,
    organization_size: PropTypes.string.isRequired,
    organization_types: PropTypes.array.isRequired,
    logo_url: PropTypes.string,
    description: PropTypes.string,
    countries_with_offices: PropTypes.array,
    active_jobs_count: PropTypes.number,
    is_devex_member: PropTypes.bool,
  }).isRequired,
};

export default Result;
